
import requests from "./httpService";

const CashVoucherServices = {
  // ==========================================
  // STORE / CASHBOOK DROPDOWNS
  // Reuse existing APIs
  // ==========================================

  getStores: async () => {
    return requests.get(
      "/cash-passbook-viewer/stores"
    );
  },

  getPassbooks: async (storeId) => {
    const params = new URLSearchParams();

    if (storeId) {
      params.set("storeId", String(storeId));
    }

    return requests.get(
      `/cash-passbook-viewer/passbooks?${params.toString()}`
    );
  },

  // ==========================================
  // ELIGIBLE CASH OUT ENTRIES
  // Only approved, unvouchered entries
  // ==========================================

  getEligibleEntries: async ({
    passbookId,
    voucherDate
  }) => {
    const params = new URLSearchParams({
      passbookId: String(passbookId),
      voucherDate: String(voucherDate)
    });

    return requests.get(
      `/cash-vouchers/eligible?${params.toString()}`
    );
  },

  // ==========================================
  // GENERATE NEW VOUCHER
  // ==========================================

  generateVoucher: async ({
    passbookId,
    voucherDate,
    entryIds
  }) => {
    return requests.post(
      "/cash-vouchers",
      {
        passbookId,
        voucherDate,
        entryIds
      }
    );
  },

  // ==========================================
  // MERGE INTO EXISTING VOUCHER
  // ==========================================

  mergeVoucher: async (
    voucherId,
    entryIds
  ) => {
    return requests.post(
      `/cash-vouchers/${encodeURIComponent(
        voucherId
      )}/merge`,
      {
        entryIds
      }
    );
  },

  // ==========================================
  // GENERATED VOUCHER LIST
  // ==========================================

  
getVouchers: async (filters = {}) => {
    const params = new URLSearchParams();

    [
        "storeId",
        "passbookId",
        "voucherDate",
        "page",
        "limit"
    ].forEach((key) => {
        const value = filters[key];

        if (
            value !== undefined &&
            value !== null &&
            value !== ""
        ) {
            params.set(key, String(value));
        }
    });

    const query = params.toString();

    return requests.get(
        `/cash-vouchers${query ? `?${query}` : ""}`
    );
},


  // ==========================================
  // SINGLE VOUCHER DETAILS / PRINT DATA
  // ==========================================

  getVoucher: async (voucherId) => {
    return requests.get(
      `/cash-vouchers/${encodeURIComponent(
        voucherId
      )}`
    );
  }
};

export default CashVoucherServices;
